import { Recipe as RecipeTemplate } from '@/components/organisms';

import type { TypeRecipeProps } from '@/organisms/recipe';

const Recipe = ({ id, bloque }: { id: string; bloque: TypeRecipeProps }) => (
  <section id={id} className="px-4 py-4 md:py-8">
    <div className="u-wrapper flex flex-col gap-4">
      <RecipeTemplate {...bloque} />
    </div>
  </section>
);

Recipe.displayName = 'Recipe';
export default Recipe;
